<template>
  <UDashboardPanel id="users" :ui="{ body: 'h-full w-full sm:p-0 p-0' }">
    <template #body>
      <div class="flex flex-col gap-4 sm:gap-6 lg:gap-12 w-full lg:max-w-3xl mx-auto">
        <UAlert
          v-if="isSupplierSuperUser && !groupsLoading && groups.length === 0"
          color="amber"
          variant="subtle"
          title="You don't have any supplier roles assigned. Contact your administrator."
          icon="i-heroicons-exclamation-triangle"
        />
        <CreateUserForm
          v-else
          :employers="employers"
          :groups="groups"
          :is-supplier-super-user="isSupplierSuperUser"
          :employers-loading="employersLoading"
          :groups-loading="groupsLoading"
          @user-created="onUserCreated"
        />
      </div>
    </template>
  </UDashboardPanel>
</template>

<script setup lang="ts">
import { api, EmployerPartnerDto, GroupDto } from '@/api/eOrdersApi';
import CreateUserForm from '@/components/users/CreateUserForm.vue';
import { useApiAdapter, useUser } from '@/store';
import { Permission } from '@/types/enums/Permission';
import { computed, onMounted, ref } from 'vue';

const apiAdapter = useApiAdapter();
const userStore = useUser();

const isSupplierSuperUser = computed(() => userStore.hasPermission(Permission.SupplierSuperUser))
const employersLoading = ref(true)
const groupsLoading = ref(true)

const employers = ref<EmployerPartnerDto[]>([])
const groups = ref<GroupDto[]>([])

async function loadEmployers() {
  const result = await apiAdapter.invoke(
    (cfg) => api.getEmployerPartners(cfg)
  );
  
  if (result) employers.value = result;
  
  employersLoading.value = false;
}

async function loadGroups() {
  const result = await apiAdapter.invoke(
    (cfg) => api.groups(cfg)
  );
  
  if (result) groups.value = result;
  
  groupsLoading.value = false;
}

function onUserCreated() {
  loadEmployers();
  loadGroups();
}

onMounted(() => {
  loadEmployers()
  loadGroups()
})
</script>
